









































import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  VideoGroupData, getGroupInfo, postGroup, putGroup, VideoGroupPointData
} from '@/api/videoDevice/play'
import { showVaildMsg } from '@/configs/validate'
import Element from 'element-ui'
import FormDialog from '@/components/dialog/formDialog.vue'
import { copyObject, newGuid } from '@/configs/functions'

const getFormRules = (form: { [key: string]: string | any }) => {
  return {
    GroupName: [{ required: true, message: '请输入分组名称', trigger: 'blur' }]
  }
}
@Component({
  components: {
    FormDialog
  }
})
export default class VideoGroupForm extends Vue {
  public name = 'VideoGroupForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  @Prop({ default: null })
  public openDialog!: () => void

  //表示从哪个组件过来的，回发的时候带上
  public refTarget: string = ''
  public targetId: string = ''

  public showDialog: boolean = false
  public expandNames: string[] = ['info']
  public loading = false

  public form = new VideoGroupData()
  public rules: any = getFormRules(this.form)
  // dynamic component
  public $refs!: {
    formData: Element.Form
  }
  public created() {
  }
  public maxNum: number = window.hikVideoCount
  public isRotation: boolean = false
  public mounted() {
    //新增，修改id
    window.eventBus.$on('openVideoGroupForm', (data: { id: number, targetId: string }) => {
      this.isRotation = false
      this.maxNum = window.hikVideoCount
      this.refTarget = data.targetId
      this.open()
      // 新增空实体，修改id获取
      this.fetchData(data.id)
    })
    //新增，修改id
    window.eventBus.$on('openVideoGroupForm_points', (data: { points: VideoGroupPointData[], targetId: string }) => {
      this.isRotation = false
      this.refTarget = data.targetId
      this.open()
      this.form = new VideoGroupData()
      this.form.PointList = data.points
    })
    window.eventBus.$on('openVideoGroupForm_rotation', (data: { targetId: string, form: any, num: number }) => {
      this.isRotation = true
      this.refTarget = data.targetId
      this.maxNum = data.num
      this.open()
      //前端操作
      //新增时：data.form 传 null，这里直接定一个新实体
      this.form = new VideoGroupData()
      //不为null就是修改
      if (data.form) {
        this.form = copyObject(data.form)
      }
    })
    window.eventBus.$on('submitSearchVideoPoint', (info: any) => {
      if (this.targetId = info.targetId) {
        this.addPoints(info.data)
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openVideoGroupForm')
    window.eventBus.$off('submitSearchVideoPoint')
  }
  public open() {
    if (!this.isRotation && this.openDialog) {
      this.openDialog()
    }
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (!this.isRotation && this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(id: number) {
    this.form = new VideoGroupData()
    this.loading = true
    if (id > 0) {
      getGroupInfo(id).then((response: { data: any }) => {
        var f = response.data
        this.form = f
        this.rules = getFormRules(f)
        this.$nextTick(() => {
          if (this.$refs.formData) {
            this.$refs.formData.clearValidate()
          }
        })
        this.loading = false
      })
        .catch((error: any) => {
          console.log(error)
        })
    }
    else {
      this.rules = getFormRules(this.form)
      this.$nextTick(() => {
        if (this.$refs.formData) {
          this.$refs.formData.clearValidate()
        }
      })
      this.loading = false
    }
  }
  public searchPoints() {
    if (this.targetId == '') {
      this.targetId = newGuid()
    }
    window.eventBus.$emit("openSearchVideoPoint", this.targetId)
  }
  public addPoints(data: any[]) {
    let f = this.form
    data.forEach((e: any, i: number) => {
      const index: number = f.PointList.findIndex((v: any) => v.VideoPointId === e.Id)
      if (index < 0) {
        f.PointList.push({
          Id: 0,
          GroupId: 0,
          GroupName: '',
          GroupSeq: 0,
          Sequence: 0,
          VideoPointId: e.Id,
          Online: e.Online,
          PointNumber: e.PointNumber,
          PointName: e.PointName,
          StreamMode: e.StreamMode
        })
      }
    })
  }
  public delPoint(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.PointList.splice(index, 1)
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消操作' })
      })
  }
  public sendData(data: VideoGroupData) {
    window.eventBus.$emit('submitVideoGroupForm', {
      targetId: this.refTarget,
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        var pointCount = f.PointList.length
        if (pointCount == 0) {
          this.$message.warning('请添加视频')
          return false
        }
        if (pointCount > this.maxNum) {
          this.$message.warning('视频数量不能大于' + this.maxNum + '个')
          return false
        }

        //如果是轮播组，不需要提交到后端，在轮播表单中统一提交
        if (this.isRotation) {
          this.sendData(f)
          this.close()
        }
        else {
          const f = Object.assign({}, this.form)
          const promist = f.Id > 0 ? putGroup(f.Id, f) : postGroup(f)
          promist.then((response: { data: any }) => {
            const data = response.data
            const msg = f.Id > 0 ? '保存' : '创建'
            if (data && !data.IsError) {
              this.$message({
                message: `${msg}成功`,
                type: 'success'
              })
              this.sendData(f)
              this.close()
            } else {
              this.$message({
                dangerouslyUseHTMLString: true, message: `${data.Message}`,
                type: 'warning'
              })
            }
          },
            (data: any) => {
              console.log(data)
            }
          )
        }
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
